<ll-titulo>{{ "dudas.titulo_crear" | t }}</ll-titulo>

<duda-new
    [item_id]="item_id"
    [item_type]="item_type"
    [item_categoria]="item_categoria"
    [showCursos]="showCursos"
    [fromProfesor]="fromProfesor"
></duda-new>
